module.exports = __webpack_public_path__ + "img/introductionOrange.57529321.jpg";